import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { replaceStatusChangedItem, removeSelectedItem } from '@/helpers/CRUD';
import { extractError } from '@/helpers/extractApiError';
import MemberService from '@/services/UsersServices/MemberService';
import { deleteMember } from '../delete/deleteSlice';

const model = {
    data: [],
    totalItems: 0,
    loading: false,
    error: null,
    successOnMemberStatusChange: '',
};

export const getMemberList = createAsyncThunk(
    'member/getMemberList',
    async (data, { rejectWithValue }) => {
        try {
            const response = await MemberService.getMemberList(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

export const changeMemberStatus = createAsyncThunk(
    'member/changeMemberStatus',
    async (data, { rejectWithValue }) => {
        try {
            const response = await MemberService.changeMemberStatus(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const memberListSlice = createSlice({
    name: 'memberList',
    initialState: model,
    reducers: {
        resetChangeMemberStatusStateOnSuccess: (state) => {
            state.successOnMemberStatusChange = '';
        },
        resetChangeMemberStatusStateOnError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // member list
        builder.addCase(getMemberList.pending, (state) => {
            state.loading = true;
        }).addCase(getMemberList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.members;
            state.totalItems = action.payload.total;
        }).addCase(getMemberList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // change member status
        builder.addCase(changeMemberStatus.pending, (state) => {
            state.loading = true;
        }).addCase(changeMemberStatus.fulfilled, (state, action) => {
            state.loading = false;
            state.successOnMemberStatusChange = 'Member status changed successfully!';
            state.data = replaceStatusChangedItem(
                state.data,
                action.payload.id,
                action.payload.status,
            );
        }).addCase(changeMemberStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Handle deleting member
        builder.addCase(deleteMember.fulfilled, (state, action) => {
            state.data = removeSelectedItem(state.data, action.payload.memberId);
            state.totalItems -= 1;
        });
    },
});

export const {
    resetChangeMemberStatusStateOnSuccess,
    resetChangeMemberStatusStateOnError,
} = memberListSlice.actions;

export default memberListSlice.reducer;
